/**
 * [helper] check is element on page
 */
const isOnPage = (elementID) => ($(elementID).length > 0);

const loadPost = (btn, url) => {
  const { postId } = btn.dataset;

  $.fancybox.open({
    src: `${url}${postId}`,
    type: 'ajax',
  });
};

export { isOnPage, loadPost };
